import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"
import useScreenType from "components/ProjectNonSpecificComponents/Hooks/useScreenType"
import { usePTKMStore } from "components/ProjectSpecificComponents/Contexts/PTKMStoreContext"
import Select from "components/ProjectSpecificComponents/Elements/Global/atoms/Select"
import { isReactSelectSingleOption } from "components/ProjectSpecificComponents/Interfaces/ExternalComponentsInterfaces"
import { defaultPriorityField } from "components/ProjectSpecificComponents/Stores/PTKMStore/defaults"
import { observer } from "mobx-react"
import React from "react"
import { useTranslation } from "react-i18next"
import FormField from "../FormField"
import { PTKM_REQ_CLASSNAME } from "./ActivatePTKMForm"

interface Props {}

const DeadlineFormFieldsSelects = observer(({}: Props) => {
	const { isMobile } = useScreenType()
	const { t } = useTranslation()
	const ptkmStore = usePTKMStore()

	const resetOldDeadlineValues = () => {
		ptkmStore.editPTKMconfig("deadlines", {
			priorityField: {
				...ptkmStore.ptkmConfig.deadlines.priorityField,
				rlaKrHours: {},
			},
		})
	}

	return (
		<HyperDiv direction={isMobile ? "column" : "row"} padding="0 1rem">
			<HyperDiv height="inherit" width={isMobile ? undefined : 250}>
				<FormField
					label={`${t("forms.field-label.priority-picklist")}*`}
					placeholderValue=""
					editable
					direction={isMobile ? "Horizontal" : "Vertical"}
				>
					<Select
						className={PTKM_REQ_CLASSNAME}
						valueKey={ptkmStore.ptkmConfig.deadlines?.priorityField?.fieldKey}
						options={ptkmStore.mainFieldOptions.picklist}
						onChange={(selectedOption) => {
							ptkmStore.editPTKMconfig("deadlines", {
								priorityField: isReactSelectSingleOption(selectedOption)
									? {
											...ptkmStore.ptkmConfig.deadlines.priorityField,
											fieldKey: selectedOption.value,
									  }
									: defaultPriorityField,
							})

							resetOldDeadlineValues()
						}}
						placeholder=""
					/>
				</FormField>
			</HyperDiv>

			<Whitespace x="3" h />

			<HyperDiv height="inherit" width={isMobile ? undefined : 250}>
				<FormField
					label={t("forms.field-label.scnd-priority-picklist")}
					placeholderValue=""
					editable
					direction={isMobile ? "Horizontal" : "Vertical"}
				>
					<Select
						valueKey={ptkmStore.ptkmConfig.deadlines?.priorityField.secondFieldKey}
						options={ptkmStore.mainFieldOptions.picklist}
						onChange={(selectedOption) => {
							ptkmStore.editPTKMconfig("deadlines", {
								priorityField: isReactSelectSingleOption(selectedOption)
									? {
											...ptkmStore.ptkmConfig.deadlines.priorityField,
											secondFieldKey: selectedOption.value,
									  }
									: defaultPriorityField,
							})

							resetOldDeadlineValues()
						}}
						placeholder=""
					/>
				</FormField>
			</HyperDiv>
		</HyperDiv>
	)
})

export default DeadlineFormFieldsSelects
